import React from 'react';
import { Grid, Box, Typography } from '@mui/material';

const InfoBox = ({
  title,
  description,
  quantity,
  color,
  suffix_uom,
  prefix_uom,
}) => (
  <Box
    sx={{
      color: '#000',
      textAlign: 'left',
      borderRadius: 1,
      border: '1px solid #B2B5C4',
      backgroundColor: '#fff',
      p: 1.5,
    }}
  >
    <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
      {title || 'No Title'}
    </Typography>

    <Typography sx={{ fontSize: 20, fontWeight: 700, color, mb: 1 }}>
      <Typography
        component='span'
        sx={{ fontSize: 14, fontWeight: 500 }}
      >
        {prefix_uom || ''}{' '}
      </Typography>
      {quantity || '0'}{' '}
      <Typography
        component='span'
        sx={{ fontSize: 14, fontWeight: 500 }}
      >
        {suffix_uom || ''}
      </Typography>
    </Typography>

    <Typography
      sx={{
        fontSize: 12,
        fontWeight: 600,
        color: '#8E92A8',
        textAlign: 'right',
      }}
    >
      {description || 'No Description'}
    </Typography>
  </Box>
);

const PoSummaryCard = ({ orderSummary = {} }) => {
  const orderInfo = [
    {
      data: orderSummary?.pending_purchase_order_info || {},
      defaultColor: '#E53636',
    },
    {
      data: orderSummary?.delivered_order_info || {},
      defaultColor: '#079551',
    },
  ];

  return (
    <Grid
      container
      spacing={2}
      sx={{ width: '50%', mt: 1 }}
    >
      {orderInfo.map(({ data, defaultColor }, index) => (
        <Grid
          key={index}
          item
          xs={12}
          sm={5}
        >
          <InfoBox
            title={data.primary_display_title}
            description={data.secondary_display_title}
            quantity={data.quantity}
            color={data.color || defaultColor}
            suffix_uom={data.suffix_uom}
            prefix_uom={data?.prefix_uom}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default PoSummaryCard;
